import * as types from './mutations_type' ;

export default {
    [types.SET_NOTES_LIST_BSCROLL](state , obj){
        state.notesListBScroll = obj ;
    },
    [types.SET_LOADING](state , bool){
        state.loading = bool ;
    },
    [types.SET_QRCODE_POLLING](state , bool){
        state.qrCodePolling = bool ;
    },
}